<template>
	<div>
		<p>Projet</p>
		<b-form-select
			:style="'max-width: ' + 500 + 'px'"
			@change="update_project"
			v-model="project_id"
			:options="projects_options"></b-form-select>
		<div v-show="project_id">
			<b-button variant="link" v-b-toggle="'collapse-project-' + id">Paramètres</b-button>
			<b-collapse :id="'collapse-project-' + id">
				<div :id="'jsoneditor-project-' + id"></div>
			</b-collapse>
		</div>
		<c_treatment_params v-show="project_id" ref="treatment_params" @change="change_treatment_params" :dashboard="false"></c_treatment_params>
		<div v-show="results_arr.length > 0" :style="'max-width: ' + (size - 100) + 'px'">
			<p>Données de tests</p>
			<edit_tabulator :extern_file="false" ref="edit_tabulator"></edit_tabulator>
			<b-button @click="test">Test</b-button>
		</div>
		<div v-if="spinner" class="center_spinner">
			<fade-loader></fade-loader>
		</div>
		<div v-show="results_arr_project.length > 0" :style="'max-width: ' + (size - 100) + 'px'">
			<p>Résultats</p>
			<edit_tabulator :extern_file="false" ref="edit_tabulator_result"></edit_tabulator>
		</div>
	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";
	import { JSONEditor } from "@json-editor/json-editor";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";
	
	const clone = require("clone");
	const _ = require("underscore");
	
	import treatments from "../services/treatments.js";
	import { schema_projet } from "../schemas-JSON/projet.js"
	import edit_tabulator from "../components/edit_tabulator.vue";
	import c_treatment_params from "../components/params.vue"

	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	export default {
		name: "document_extraction_post_treatment",
		components: {
			edit_tabulator,
			FadeLoader,
			c_treatment_params
		},
		props: {
			start_name: {},
			projects: {
				default: () => [],
			},
			projects_options: {
				default: () => [],
			},
			results_arr: {
				default: () => []
			},
			scenario: {},
			size: {},
			pre_treatment: {
				default: false
			}
		},
		watch: {
			results_arr: async function()
			{
				this.$refs.edit_tabulator.set_data(this.results_arr);
			}
		},
		data() {
			return {
				id: uniqueId(""),
				project_editor: null,
				parameters: {},

				project_id: "",
				project: null,
				params: null,

				results_arr_project: [],
				step: true,
				spinner: false,

				treatment_params: []
			};
		},
		methods: {
			async save() {
				var data = {
					name: this.parameters.name,
					project_id: this.project_id,
					project: this.project,
					params: this.params
				};

				return data;
			},
			async load(data) {

				//console.log(data)

				this.step = false;

				this.position_parent = data.position_parent || null;
				this.position = data.position || null;

				this.project_id = data.project_id || "";
				this.project = data.project || null;
				this.params = data.params || null;

				if (this.project_id)
				{
					for (var i = 0; i < this.projects.length; i++) {
						if (this.projects[i].uid == this.project_id) {
							this.project = this.projects[i];
						}
					}
				}

				if (this.project_id)
				{

					var params = null;
					if (this.params && this.params.params)
						params = clone(this.params.params);
						
					await this.setParameters(this.params)

					this.treatment_params = this.project.details.treatment_params || [];

					await this.$refs.treatment_params.set(this.treatment_params);

					// console.log(this.project)
					await this.setParameters();

					if (params)
					{
						this.$refs.treatment_params.set_obj(params);
					}
				}

				this.step = true
			},
			async update_project() {
				if (!this.project_id)
				{
					this.scenario.deleteStepByDescription("Post t columns");
					this.scenario.deleteStepByDescription("Pre treatment");
					this.project = null;
					this.params = null;
					return;
				}

				// console.log(this.project_id)
				for (var i = 0; i < this.projects.length; i++) {
					if (this.projects[i].uid == this.project_id) {
						this.project = this.projects[i];

						this.treatment_params = this.project.details.treatment_params || [];
						await this.$refs.treatment_params.set(this.treatment_params);

						// console.log(this.project)
						await this.setParameters();

						if (this.params)
						{
							this.$refs.treatment_params.set_obj(this.params.params);
						}

						break;
					}
				}
			},
			change_treatment_params()
			{
				var params = this.project_editor.getValue();
				params.params = this.$refs.treatment_params.get_obj();
				
				this.project_editor.setValue(params);
			},
			async setParameters(params = null)
			{
				var self = this;

				if (this.project_editor) {
					this.project_editor.destroy();
					this.project_editor = null;
				}

				var json = {};
				json.project = this.project ? this.project.uid : null;
				var schema = schema_projet(json);
				
				const element = document.getElementById(
					"jsoneditor-project-" + this.id
				);
				
				this.project_editor = new JSONEditor(element, {
					schema: schema,
					keep_oneof_values: false,
					theme: "bootstrap4",
					iconlib: "fontawesome5",
					prompt_before_delete: false,
					object_background: "",
					display_required_only: true,
					disable_edit_json: false,
					disable_properties: false,
					template: "handlebars",
				});
				
				await new Promise((resolve, reject) => {
					self.project_editor.on("ready", function () {
						resolve();
					});
				});

				this.params = null;
				this.project_editor.on("change", function () {

					self.params = self.project_editor.getValue();

					self.$refs.treatment_params.set_obj(self.params.params);

					if (self.step)
					{
						if (self.pre_treatment)
						{
							if (self.project_id)
							{
								if (self.scenario.existStepByDescription("Pre treatment"))
								{
									console.log("exist")
									self.scenario.updateStepParametersByDescription("Pre treatment", self.params, self.project_id);
								}
								else
								{
									self.scenario.addStep({
										data: {
											action: "projet",
											label: "Pre treatment",
											parameters: self.params,
											sql_rules: "",
										},
										description: "Pre treatment",
										action: "projet",
										c_conditions: false,
										c_tree: false,
										c_project: true,
										project_id: self.project_id,
										c_parameters: true,
										c_tabulator: false,
										c_test: true,
										tabulator2: [],
										keep_start_data: false,
										option_delete: false,
										option_make_list: false,
										treatment: false,
									}, true);
								}
							}
							else if (self.scenario)
								self.scenario.deleteStepByDescription("Pre treatment");			
						}
						else
						{
							if (self.project_id)
							{
								if (self.scenario.existStepByDescription("Post t columns"))
								{
									console.log("exist")
									self.scenario.updateStepParametersByDescription("Post t columns", self.params, self.project_id);
								}
								else
								{
									self.scenario.addStep({
										data: {
											action: "projet",
											label: "Post t columns",
											parameters: self.params,
											sql_rules: "",
										},
										description: "Post t columns",
										action: "projet",
										c_conditions: false,
										c_tree: false,
										c_project: true,
										project_id: self.project_id,
										c_parameters: true,
										c_tabulator: false,
										c_test: true,
										tabulator2: [],
										keep_start_data: false,
										option_delete: false,
										option_make_list: false,
										treatment: false,
									}, null, ["Analyse pdf - ", "Post t - ", "Mapping", "modification_columns", "columns"]);
								}
							}
							else
								self.scenario.deleteStepByDescription("Post t columns");
						}
					}
				});

				if (params)
				{
					this.project_editor.setValue(params);
					this.$refs.treatment_params.set_obj(params.params);
				}
				else
				{
					this.project_editor.setValue({
						project: this.project_id, 
						params: {
						}
					});
				}
			},
			async test()
			{
				this.spinner = true;
				var formData = new FormData();

				var files = await this.$refs.edit_tabulator.get_data_files();
				formData.append(files[0].name, files[0]);

				var resp = await this.test_project(
					this.project,
					formData,
					this.params.tags,
					[],
					"",
					true,
					[],
					0,
					{},
					this.params,
					[],
					uniqueId()
				);

				console.log(resp)

				this.results_arr_project = resp.results || [];
				var columns = _.difference(Object.keys(this.results_arr_project[0]), Object.keys(this.results_arr[0]))
				this.$refs.edit_tabulator_result.set_data(resp.results, columns);
				this.spinner = false;
			},
			async test_project(
				project,
				formData,
				tags,
				results_files,
				name_file,
				first_csv,
				urls,
				nb_step, 
				step,
				params,
				treatment_params,
				step_uid
			) {
				var results = []
				var tag_data = {};
				if (project.tags && tags) {
					for (var i = 0; i < project.tags.length; i++) {
						if (project.tags[i].tag == tags)
							tag_data = project.tags[i];
					}
				}
				var treatment_data = await treatments.create(
					project.uid,
					null,
					null,
					null,
					[tags],
					tag_data.type_import || "import",
					formData,
					params,
					treatment_params,
					step_uid
				).catch((err) => {
                    console.log("error : " + err);
                    this.$notify({
                        group: "info",
                        title: err.response.data.msg,
                        type: "error",
                    });
                });
				while (
					treatment_data.treatment.resultat != "ok" &&
					treatment_data.treatment.resultat != "ko"
				) {
					await new Promise((resolve) => setTimeout(resolve, 2000));
					treatment_data = await treatments.get(
						treatment_data.treatment.uid
					);
				}
				var all_files = await treatments.getFiles(
					treatment_data.treatment.uid
				);
				if (!all_files || all_files.length == 0) all_files = [];
				all_files.sort((a, b) =>
					a.nom_fichier > b.nom_fichier ? 1 : -1
				);
				var export_type = tag_data.type_export || "export";
				for (var i = 0; i < all_files.length; i++) {
					if (nb_step <= 1) {
						if (
							first_csv &&
							all_files[i].type == export_type &&
							all_files[i].nom_fichier.endsWith(".csv") &&
							!step.file_result
						) {
							var csv_data = await treatments.getFile(
								all_files[i].uid,
								all_files[i].nom_fichier,
								false,
								false
							);
							name_file = all_files[i].nom_fichier;
							results = this.$papa.parse(csv_data, {
								header: true,
							});
							results = results.data;
							first_csv = false;
						} else if (all_files[i].type == export_type) {
							urls.push({
								url: all_files[i].url,
								name: all_files[i].nom_fichier,
							});
						}
					} else {
						if (all_files[i].type == export_type)
							urls.push({
								url: all_files[i].url,
								name: all_files[i].nom_fichier,
							});
					}
				}

				return { name_file, first_csv, urls, results };
			},
			destroy()
			{
				this.scenario.deleteStepByDescription("Post t columns");
			}
		},
		destroyed: async function() {
		},
		mounted: async function () {
			var self = this;

			this.setParameters();
		},
	};
</script>

<style></style>
